import * as React from "react";
import { useIntl } from "react-intl";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/system";
import { Button, Grid, ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import { useLoading } from "./LoadingContext";
import axios from "../api/axiosClient"
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
} from "../services/serviceBase";

import { useSelector, useDispatch } from "react-redux";
import {
  setCompany,
  setCurrentItemMenuId,
  setOpenedMenuItems,
  setWithStealthFlow
} from "../redux/commonSlice";
import { resetActAs } from "../redux/actasSlice";

const CustomMenuItem = (props) => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const intl = useIntl();

  const openedMenuItems = useSelector((state) => state.common.openedMenuItems);
  const currentItemMenuId = useSelector(
    (state) => state.common.currentItemMenuId
  );
  const company = useSelector((state) => state.common.company);

  const [open, setOpen] = useState(() => {
      let menu = openedMenuItems != null && openedMenuItems != undefined ? openedMenuItems.find(x => x == props.Id) : undefined
      return menu != undefined && menu != null 
  });

  const dispatch = useDispatch();

  const handleClick = (event, id) => {
    event.preventDefault();
    dispatch(setOpenedMenuItems({id: id, open: !open}));
    setOpen(!open);
    //getWithStealthFlowsFlag(id);
  };

  const getClassNameOfMenuItem = (item) => {
    var selectedClass = item.Id == currentItemMenuId ? "selectedMenuItem" : "";
    //var colorClass = item.Root ? "apeBlueColor" : "apeLigthBlueColor";
    var colorClass = "apeBlueColor";

    if (item.Class != null && item.Class != undefined && item.Class != "") {
      colorClass = item.Class;
    }

    return colorClass + " " + selectedClass;
  };

    const handleLinkClick = (event, id) => {
      if(props.Company !== undefined && props.Company !== null && props.Company != company) {
        getWithStealthFlowsFlag(props.Company);
        dispatch(setCompany(props.Company));  
        dispatch(resetActAs());
      }
      dispatch(setCurrentItemMenuId(id));
  };

  const renderCollapseElement = (item) => {
    if (item.IsVisibleEntry) {
      return (
        <Collapse id={item.Id} in={open} timeout="auto" unmountOnExit key={item.Id}>
          <List component="div" key={item.Id}>
            <ListItem
              className={getClassNameOfMenuItem(item)}
              sx={{ pl: 4 }}
              component={Link}
              to={item.Link}
              onClick={(event) => handleLinkClick(event, item.Id)}
            >
              <strong>
                {item.Name}
              </strong>
            </ListItem>
          </List>
        </Collapse>
      );
    } else {
      return null;
    }
  };

  const renderElement = (item) => {
    if (item.IsVisibleEntry) {
      return (
            <ListItem
              className={getClassNameOfMenuItem(item)}
              sx={{ pl: 2, mt: 2 }}
              component={Link}
              to={item.Link}
              onClick={(event) => handleLinkClick(event, item.Id)}
            >
              <strong>
                {item.Name}
              </strong>
            </ListItem>
      );
    } else {
      return null;
    }
  };

  const renderChildren = (item, company) => {
    if (item.IsVisibleEntry) {
      return (
        <Box sx={{ pl: 2 }}>
          <CustomMenuItem
            Name={item.Name}
            key={item.Id}
            Id={item.Id}
            Children={item.Children}
            Company={company}
          />
        </Box>
      );
    } else {
      return null;
    }
  };

  const ShowChildren = (children, company) => {
    if (children !== null && children != [] && children !== undefined) {
      return children.map((x) => (
        <Collapse
          in={open}
          timeout="auto"
          unmountOnExit
          key={x.Id}
          id={x.Id}
        >
          {x.Children === undefined
            ? renderCollapseElement(x)
            : renderChildren(x, company)}
        </Collapse>
      ));
    } else {
      return null;
    }
  };

  const getWithStealthFlowsFlag = (idCompany) => {
    setLoading(true);
    axios
      .get(`/masterdata/Companies/${idCompany}`)
      .then((response) => {
        setLoading(false);
        dispatch(setWithStealthFlow(response.data));
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Box
      key={props.Id}
      sx={{ width: "100%", maxWidth: 300 }}
    >
      {
        props.Children !== null && props.Children != [] && props.Children !== undefined ? 
        (
          <Grid container onClick={(event) => { handleClick(event, props.Id)} } id={props.id} sx={{ p: 2 }}>
            <Grid item xs={10}>
              <ListItemText className="apeBlueColor">
                <strong>
                  {props.Name}
                </strong>
              </ListItemText>
            </Grid>
            <Grid item xs={2}>
              {open ? (
                <ExpandLess className="apeBlueColor" />
              ) : (
                <ExpandMore className="apeBlueColor" />
              )}
            </Grid>
          </Grid>
        ) : <Box> </Box>
      }
      {
        props.Children !== null && props.Children != [] && props.Children !== undefined ? ShowChildren(props.Children, props.Company) : renderElement(props) 
      }
      
    </Box>
  );
};

export default CustomMenuItem;
